module.exports = __webpack_public_path__ + "media/western-wood-pewee-2.73f92981.mp3";